import { createFileRoute } from '@tanstack/react-router'
import Moderation from '@/features/moderation'

export const Route = createFileRoute('/_authenticated/moderation/')({
  component: Moderation,
})
